import Swal from 'sweetalert2';
import Icon from "@mui/material/Icon";
import Dashboard from "layouts/dashboard";
import Category from "layouts/tables/Category";
import Notification from "layouts/tables/notification";
import DiscountCode from "layouts/tables/discount_code";
import InventoryIcon from "@mui/icons-material/Inventory";
import SalesReport from "layouts/tables/Reports/sales_report";
import ProductDetails from "layouts/tables/Product_Details";
import OrderDetails from "layouts/tables/order_details";
import VendorUserProfile from "layouts/tables/user_profile/vendor_user_profile";
import api from 'core/interceptors/api';
import StockUpdate from "layouts/tables/Product_Details/StockUpdate";
import StockHistory from "layouts/tables/Product_Details/StockHistory";
import InactiveProductsPage from 'layouts/tables/Product_Details/InactiveProductsPage';
const allRoutes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/dashboard",
    component: <Dashboard />,
    permissionKey: "dashboard",
  },
  {
    type: "collapse",
    name: "User Profile",
    key: "user-profile-vendor",
    icon: <Icon fontSize="small">person</Icon>,
    route: "/vendor/UserProfile",
    component: <VendorUserProfile />,
    permissionKey: "user_profile",
  },


  {
    type: "collapse",
    name: "Product Management",
    key: "product-management",
    icon: <Icon fontSize="small">local_mall</Icon>,
    permissionKey: "product_management",
    children: [
      {
        type: "collapse",
        name: "Categories",
        key: "categories",
        icon: <Icon fontSize="small">category</Icon>,
        route: "/product_management/Category",
        component: <Category />,
      },
      {
        type: "collapse",
        name: "Product Details",
        key: "products",
        icon: <Icon fontSize="small">list_alt</Icon>,
        route: "/product_management/Products",
        component: <ProductDetails />,
      },
      {
        type: "collapse",
        name: "Inactive Products",
        key: "inactive_products",
        icon: <Icon fontSize="small">list_alt</Icon>,
        route: "/product_management/inactive_products",
        component: <InactiveProductsPage />,
      },
      {
        type: "collapse",
        name: "Stock Management",
        key: "stock-update",
        route: "/product_management/Stock_Update",
        icon: <Icon fontSize="small">inventory_2</Icon>,
        component: <StockUpdate />,
      },
      {
        type: "collapse",
        name: "Stock History",
        key: "stock-update",
        route: "/product_management/Stock_History",
        icon: <Icon fontSize="small">inventory_2</Icon>,
        component: <StockHistory />,
      },
    ],
  },
  {
    type: "collapse",
    name: "Order Management",
    key: "order-management",
    icon: <Icon fontSize="small">store</Icon>,
    permissionKey: "order_management",
    children: [
      {
        type: "collapse",
        name: "Order Details",
        key: "order-details",
        icon: <Icon fontSize="small">store</Icon>,
        route: "/order_management/OrderDetails",
        component: <OrderDetails />,
      },

    ],
  },
  // {
  //   type: "collapse",
  //   name: "Discount Code",
  //   key: "discount_code",
  //   icon: <Icon fontSize="small">account_balance_wallet</Icon>,
  //   route: "/promotion_discount/discount_code",
  //   component: <DiscountCode />,
  //   permissionKey: "discount_code",
  // },
  {
    type: "collapse",
    name: "Report And Analytics",
    key: "reportandanalytics",
    icon: <Icon fontSize="small">monitoring</Icon>,
    permissionKey: "report_analytics",
    children: [
      {
        type: "collapse",
        name: "Sales Reports",
        key: "sales_reports",
        icon: <Icon fontSize="small">bar_chart</Icon>,
        route: "/reports/sales_report",
        component: <SalesReport />,
      },
    ],
  },
  {
    type: "collapse",
    name: "Notifications",
    key: "notification",
    icon: <Icon fontSize="small">notifications_icon</Icon>,
    route: "/notification",
    component: <Notification />,
    permissionKey: "notifications",
  },

];

export const fetchAndFilterRoutes = async (vendorEmail) => {
  try {
    const token = localStorage.getItem("token");

    if (!token) {
      console.error("Unauthorized: No token found");
      return [];
    }

    const [permissionsRes, profileRes] = await Promise.all([
      api.get(`/vendor_control/get_permissions?email=${vendorEmail}`),
      api.get(`/vendor_register/profile-completion/${vendorEmail}`),
    ]);

    const permissions = permissionsRes.data.permissions;
    const completionPercent = parseFloat(profileRes.data.profile_completion.replace("%", ""));

    console.log("Permissions:", permissions);
    console.log("Profile Completion:", completionPercent);

    const filterRoutes = (routes) =>
      routes
        .map((route) => {
          const isDashboard = route.key === "dashboard";
          const isUserProfile = route.key === "user-profile-vendor";

          if (isDashboard || isUserProfile) return route;

          if (completionPercent === 100) {
            if (route.children) {
              return permissions[route.permissionKey] ? route : null;
            }
            return permissions[route.permissionKey] ? route : null;
          }

          return null;
        })
        .filter(Boolean);

    const filteredRoutes = filterRoutes(allRoutes);
    console.log("Filtered Routes Based on Completion:", filteredRoutes);
    return filteredRoutes;

  } catch (error) {
    console.error("Error fetching permissions or profile completion:", error);
    return [];
  }
};


